import { normalizeCategorySecondaryImageKey } from "@b2b/ui-components";

/** Fixed Product Categories carousel on Bizcover India home (display order). */
export const HOME_PRODUCT_CATEGORY_DISPLAY = [
  { name: "Grain", image: "/home-categories/grain.jpg" },
  {
    name: "Other Agriculture Products",
    image: "/home-categories/other-agriculture-products.jpg",
  },
  {
    name: "Plant Seeds & Bulbs",
    image: "/home-categories/plant-seeds-and-bulbs.jpg",
  },
  { name: "Home Decor", image: "/home-categories/home-decor.jpg" },
  {
    name: "Other Food & Beverage",
    image: "/home-categories/other-food-and-beverage.jpg",
  },
  { name: "Women's Clothing", image: "/home-categories/womens-clothing.webp" },
  {
    name: "Agricultural Machinery & Equipment",
    image: "/home-categories/agricultural-machinery-and-equipment.jpg",
  },
  { name: "Food Ingredients", image: "/home-categories/food-ingredients.jpg" },
  {
    name: "Plant & Animal Oil",
    image: "/home-categories/plant-and-animal-oil.jpg",
  },
  { name: "Snacks", image: "/home-categories/snacks.jpg" },
  { name: "Home Textiles", image: "/home-categories/home-textiles.jpg" },
  {
    name: "Tiles & Accessories",
    image: "/home-categories/tiles-and-accessories.jpg",
  },
  { name: "Fresh Fruit", image: "/home-categories/fresh-fruit.jpg" },
  {
    name: "Hair Extensions & Wigs",
    image: "/home-categories/hair-extensions-and-wigs.avif",
  },
  {
    name: "Health Care Products",
    image: "/home-categories/health-care-products.jpg",
  },
  { name: "Jewelry", image: "/home-categories/jewelry.jpg" },
  {
    name: "Honey & Honey Products",
    image: "/home-categories/honey-and-honey-products.jpg",
  },
  { name: "Instant Food", image: "/home-categories/instant-food.jpg" },
  {
    name: "Home Storage & Organization",
    image: "/home-categories/home-storage-and-organization.jpg",
  },
] as const;

const HOME_PRODUCT_CATEGORY_IMAGE_BY_KEY = new Map<string, string>(
  HOME_PRODUCT_CATEGORY_DISPLAY.map((row) => [
    normalizeCategorySecondaryImageKey(row.name),
    row.image,
  ]),
);

export function getHomeProductCategoryDisplayImageUrl(
  displayName: string,
): string | undefined {
  return HOME_PRODUCT_CATEGORY_IMAGE_BY_KEY.get(
    normalizeCategorySecondaryImageKey(displayName),
  );
}
